import { useTranslation } from 'react-i18next'
import Support from '@/features/Settings/Support'
import SettingsLayout from '@/features/Settings/Layout'

const SupportPage = () => {
  const { t } = useTranslation()

  return (
    <SettingsLayout title={t('b.support.view.support.title', 'Support')}>
      <Support />
    </SettingsLayout>
  )
}

export default SupportPage
